import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addErrorToReport } from '@americanexpress/one-app-ducks';

export class AnalyticsErrorBoundaryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { dispatch } = this.props;
    try {
      dispatch(
        addErrorToReport(error, {
          collectionMethod: 'AnalyticsErrorBoundary',
          moduleID: 'banking-root',
          info: errorInfo,
        })
      );
    } catch (errorReportException) {
      // Swallow as there's no rescuing failed error reporter.
    }
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      // If Analytics fails unmount analytics components
      return null;
    }

    return children;
  }
}

AnalyticsErrorBoundaryComponent.propTypes = {
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

const AnalyticsErrorBoundary = connect()(AnalyticsErrorBoundaryComponent);

export default AnalyticsErrorBoundary;
